/**
 * 创建: 王伟
 * 邮箱：wangw@wondershare.cn
 * 时间: 2015/2/7 16:01
 * 描述:
 * 贝塞尔曲线请访问 http://cubic-bezier.com/ 进行调试
 * 查看
 */
(function (win) {
    var requestAnimationFrame = win.requestAnimationFrame || win.webkitRequestAnimationFrame || function (callback) { win.setTimeout(callback, 1000 / 60); },
        cancelAnimationFrame = win.cancelRequestAnimationFrame || win.webkitCancelRequestAnimationFrame || win.clearTimeout,
        timeout,
        now = win.Date.now,
        stack = {},
        id = 0,
        size = 0,
        curves_obj = {},
        /**
         *  options 一下属性
         *  time 毫秒,必选
         *  loop 循环类型 "once", "loop", "once_back", "loop_back"，可选，默认一次
         *  curve，曲线，可选，默认linear，支持bezier数组[[x1, y1], [x2, y2]]
         * @param callback
         * @returns {number}
         */
        animate = win.animate = function (options, callback) {
        var time = options.time,
            loop = options.loop || "once",
            curve = options.curve;
        if (!time) {
            throw new win.RangeError("时间设置错误");
        }
        switch (typeof curve) {
            case "string":
                curve = curves_obj[curve];
                break;
            case "object":
                curve = bezier(curve);
                break;
            default :
                curve = undefined;
        }
        size++;
        stack[++id] = {
            "time": time,
            "easing": curve,
            "callback": callback,
            "stamp": now(),
            "loop": loop,
            "percent": 0,
            "pause": false
        };

        if(size === 1) {
            timeout = requestAnimationFrame(run);
        }
        return id;
    };


    /**
     * 暂停
     * @param id
     */
    animate.pause = function (id) {
        var p, item;
        if (id === undefined) {
            cancelAnimationFrame(timeout);
            for (p in stack) {
                stack[p].pause = true
            }
            size = 0;
        } else {
            item = stack[id];
            if (item && item.pause === false) {
                item.pause = true;
                size--;
                if (size === 0) {
                    cancelAnimationFrame(timeout);
                }
            }
        }
        return animate;
    };
    /**
     * 恢复pause的动画
     * @param id
     */
    animate.run = function (id) {
        var p, item, i = 0;
        if (id === undefined) {
            for (p in stack) {
                stack[p].pause = false;
                i++;
            }
            if (!size && i) {
                timeout = requestAnimationFrame(run);
            }
            size = i;
        } else {
            item =  stack[id];
            if (item && item.pause === true) {
                item.pause = false;
                size++;
                if (size === 1) {
                    timeout = requestAnimationFrame(run);
                }
            }
        }
        return animate;
    };
    /**
     * 停止
     * @param id
     */
    animate.stop = function (id) {
        var item =  stack[id];
        if (item) {
            item.callback(item.percent, -1);
            delete stack[id];
            size--;
            if (!size) {
                cancelAnimationFrame(timeout);
            }
        }
        return animate;
    };
    /**
     * 全部停止
     */
    animate.stop_all = function () {
        var p, item;
        cancelAnimationFrame(timeout);
        for (p in stack) {
            item = stack[p];
            item.callback(item.percent, -1);
        }
        stack = {};
        size = 0;
        return animate;
    };
    /**
     * 运行
     */
    function run() {
        var p,
            item,
            now_stamp = now(),
            timing,
            time,
            ratio,
            easing;
        for (p in stack) {
            item = stack[p];
            if (item.pause) {
                continue;
            }
            timing = now_stamp - item.stamp;
            time = item.time;
            easing = item.easing;
            switch (item.loop) {
                case "once":
                    ratio = timing / time;
                    if (ratio >= 1) {
                        item.callback(1, 1);
                        delete stack[p];
                        size--;
                    } else {
                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
                    }
                    break;
                case "loop":
                    ratio = timing / time;
                    if (ratio >= 1) {
                        //下一次循环开始
                        item.callback(1, 0);
                        item.percent = 1;
                        item.stamp = now_stamp;
                    } else {
                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
                    }
                    break;
                case "once_back":
                    ratio = timing * 2 / time;
                    if (timing >= time) {
                        item.callback(0, 1);
                        delete stack[p];
                        size--;
                    } else if (ratio >= 1) {
                        item.callback(item.percent = easing ? easing(2 - ratio) : 2 - ratio, 0);
                    } else {
                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
                    }
                    break;
                case "loop_back":
                    ratio = timing * 2 / time;
                    if (timing >= time) {
                        //下一次循环开始
                        item.callback(0, 0);
                        item.stamp = now_stamp;
                        item.percent = 0;
                    } else if (ratio >= 1) {
                        item.callback(item.percent = easing ? easing(2 - ratio) : 2 - ratio, 0);
                    } else {
                        item.callback(item.percent = easing ? easing(ratio) : ratio, 0);
                    }
            }

        }
        if (size) {
            timeout = requestAnimationFrame(run);
        }
    }

    /**
     * 贝塞尔曲线
     * @param coordinate
     * @returns {Function}
     */
    function bezier (coordinate) {
        var t = 0,
            x1 = coordinate[0],
            x2 = coordinate[2],
            y1 = coordinate[1],
            y2 = coordinate[3];
        if (x1 > 1 || x1 < 0 || x2 > 1 || x1 < 0) {
            alert("x坐标必须在0-1之间！");
        }
        return function (x) {
            t = bisection (x, t, x1, x2);
            var t2 = t * t,
                at = 1 - t;
            return 3 * y1 * t * at * at + 3 * y2 * t2 * at + t2 * t;
        }
    }

    /**
     * 二分法
     * @param x
     * @param pev_t
     * @param x1
     * @param x2
     * @returns {*}
     */
    function bisection (x, pev_t, x1, x2) {
        if(x === 0 || x === 1) {
            return x;
        }
        var i,
            middle,
            t0 = Math.max(0, pev_t - .2),
            t1 = Math.min(1, pev_t + .2),
            t,
            t2,
            at;
        for (i = 0; i < 20; i++) {
            t = (t0 + t1) / 2;
            t2 = t * t;
            at = 1 - t;
            middle = 3 * x1 * t * at * at + 3 * x2 * t2 * at + t2 * t;
            if (middle > x) {
                if (middle - x < 1e-6) {
                    break;
                }
                t1 = t;
            } else if (middle < x) {
                if (x - middle < 1e-6) {
                    break;
                }
                t0 = t;
            } else {
                break;
            }
        }
        return t;
    }

    /**
     * 动画曲线
     */
    (function () {
        var Math = win.Math,
            pi2 = Math.PI * 2
            ;
        curves_obj = animate.curves_obj = {
            linear: function (t) {
                return t;
            },

            quadIn: getPowIn(2),
            quadOut: getPowOut(2),
            quadInOut: getPowInOut(2),

            cubicIn: getPowIn(3),
            cubicOut: getPowOut(3),
            cubicInOut: getPowInOut(3),

            quartIn: getPowIn(4),
            quartOut: getPowOut(4),
            quartInOut: getPowInOut(4),

            quintIn: getPowIn(5),
            quintOut: getPowOut(10),
            quintInOut: getPowInOut(5),

            sineIn: function (t) {
                return 1 - Math.cos(t * Math.PI / 2);
            },
            sineOut: function (t) {
                return Math.sin(t * Math.PI / 2);
            },
            sineInOut: function (t) {
                return -0.5 * (Math.cos(Math.PI * t) - 1);
            },

            expoIn: function(t){
                return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
            },

            expoOut: function(t){
                return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
            },

            expoInOut: function(t){
                if(t === 0 || t === 1) {
                    return t;
                }
                if((t /= 0.5) < 1) {
                    return 0.5 * Math.pow(2, 10 * (t-1));
                }
                return 0.5 * (-Math.pow(2, -10 * --t) + 2);
            },

            backIn: getBackIn(1.7),
            backOut: getBackOut(1.7),
            backInOut: getBackInOut(1.7),

            circIn: function (t) {
                return -(Math.sqrt(1 - t * t) - 1);
            },
            circOut: function (t) {
                return Math.sqrt(1 - (--t) * t);
            },
            circInOut: function (t) {
                if ((t *= 2) < 1) {
                    return -0.5 * (Math.sqrt(1 - t * t) - 1);
                }
                return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
            },

            bounceIn: function (t) {
                return 1 - curves_obj.bounceOut(1 - t);
            },
            bounceOut: function (t) {
                if (t < 1 / 2.75) {
                    return (7.5625 * t * t);
                }
                if (t < 2 / 2.75) {
                    return (7.5625 * (t -= 1.5 / 2.75) * t + 0.75);
                }
                if (t < 2.5 / 2.75) {
                    return (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375);
                }
                return (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375);
            },
            bounceInOut: function (t) {
                if (t < 0.5) {
                    return curves_obj.bounceIn(t * 2) * .5;
                }
                return curves_obj.bounceOut(t * 2 - 1) * 0.5 + 0.5;
            },

            elasticIn: getElasticIn(1, 0.3),
            elasticOut: getElasticOut(1, 0.3),
            elasticInOut: getElasticInOut(1, 0.3 * 1.5),

            swingFromTo: function (pos) {
                var s = 1.70158;
                return ((pos /= 0.5) < 1) ? 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s)) :
                0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
            },
            swingFrom: function (pos) {
                var s = 1.70158;
                return pos * pos * ((s + 1) * pos - s);
            },
            swingTo: function (pos) {
                var s = 1.70158;
                return (pos -= 1 ) * pos * ((s + 1 ) * pos + s) + 1;
            },

            blink: function (t) {
                return Math.round(t * 5) % 2;
            },
            spring: function (pos) {
                return 1 - (Math.cos(pos * 4.5 * Math.PI) * Math.exp(-pos * 6));
            }
        };

        function getPowIn(pow) {
            return function (t) {
                return Math.pow(t, pow);
            };
        }

        function getPowOut(pow) {
            return function (t) {
                return 1 - Math.pow(1 - t, pow);
            };
        }

        function getPowInOut(pow) {
            return function (t) {
                if ((t *= 2) < 1) {
                    return 0.5 * Math.pow(t, pow);
                }
                return 1 - 0.5 * Math.abs(Math.pow(2 - t, pow));
            };
        }

        function getBackIn(amount) {
            return function (t) {
                return t * t * ((amount + 1) * t - amount);
            };
        }

        function getBackOut(amount) {
            return function (t) {
                return (--t * t * ((amount + 1) * t + amount) + 1);
            };
        }

        function getBackInOut(amount) {
            amount *= 1.525;
            return function (t) {
                if ((t *= 2) < 1) return 0.5 * (t * t * ((amount + 1) * t - amount));
                return 0.5 * ((t -= 2) * t * ((amount + 1) * t + amount) + 2);
            };
        }

        function getElasticIn(amplitude, period) {
            return function (t) {
                if (t == 0 || t == 1) {
                    return t;
                }
                var s = period / pi2 * Math.asin(1 / amplitude);
                return -(amplitude * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * pi2 / period));
            };
        }

        function getElasticOut(amplitude, period) {
            return function (t) {
                if (t == 0 || t == 1) {
                    return t;
                }
                var s = period / pi2 * Math.asin(1 / amplitude);
                return (amplitude * Math.pow(2, -10 * t) * Math.sin((t - s) * pi2 / period) + 1);
            };
        }

        function getElasticInOut(amplitude, period) {
            return function (t) {
                var s = period / pi2 * Math.asin(1 / amplitude);
                if ((t *= 2) < 1) {
                    return -0.5 * (amplitude * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * pi2 / period));
                }
                return amplitude * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * pi2 / period) * 0.5 + 1;
            };
        }
    })();
})(window);


// WEBPACK FOOTER //
// ./src/assets/js/animate.js